import React, { useState, useEffect, useCallback } from "react";

const TemplateVariableCard = React.memo(({post = null, current_user = null, senderVariables, receiverVariables, organizationVariable, useVariable, realign}) => {
    const [senderClicked, setSenderClicked] = useState(true)
    const [receiverClicked, setReceiverClicked] = useState(false)
    const [organizationClicked, setOrganizationClicked] = useState(false)

    // click events 
    const clickSender = useCallback(() => {
        setSenderClicked(true)
        setReceiverClicked(false)
        setOrganizationClicked(false)
    }, [])

    const clickReceiver = useCallback(() => {
        setReceiverClicked(true)
        setSenderClicked(false)
        setOrganizationClicked(false)
    }, [])

    const clickOrgnaization = useCallback(() => {
        setOrganizationClicked(true)
        setSenderClicked(false)
        setReceiverClicked(false)
    }, [])


    return (
    <div className="popup-search-three card re-cu-move">
        <div className="card-body">
            <div className="nav nav-line nav-sub nav-color-secondary cu-overflow">
                <span className={senderClicked ? 'nav-link active show' : 'nav-link'} onClick={clickSender}>
                    Sender <span className="conditional-span">Variables</span>
                </span>
                <span className={receiverClicked ? 'nav-link active show' : 'nav-link'} onClick={clickReceiver}>
                    Receiver <span className="conditional-span">Variables</span>
                </span>
                <span className={organizationClicked ? 'nav-link active show' : 'nav-link'} href="#" onClick={clickOrgnaization}>
                    Organization <span className="conditional-span">Variables</span>
                </span>
            </div>
            <hr/>

                {senderClicked && 
                    <div>
                        <ul style={{maxHeight: '350px', overflowY: 'auto'}}>
                            {senderVariables.map((field, index )=> (
                                <div onClick={() => useVariable(`{{sender.${field}}}`)} key={index}>
                                    <li>{ `{{sender.${field}}}` }</li>
                                    <hr/>
                                </div>
                            ))}
                        </ul>
                    </div>
                }

                {receiverClicked && 
                    <div>
                        <ul style={{maxHeight: '350px', overflowY: 'auto'}}>
                            {receiverVariables.map((field, index )=> (
                                <div onClick={() => useVariable(`{{receiver.${field}}}`)} key={index}>
                                    <li>{ `{{receiver.${field}}}` }</li>
                                    <hr/>
                                </div>
                            ))}
                        </ul>
                    </div>
                }

                {organizationClicked && 
                    <div>
                    <ul style={{maxHeight: '350px', overflowY: 'auto'}}>
                        {organizationVariable.map((field, index )=> (
                            <div onClick={() => useVariable(`{{organization.${field}}}`)} key={index}>
                                <li>{ `{{organization.${field}}}` }</li>
                                <hr/>
                            </div>
                        ))}
                    </ul>
                </div>
                }

            </div>
    </div>
    )
})

export default TemplateVariableCard
